
export enum Strings {
    TEST = "test",
    OK_BUTTON = "okButton",
    BACK_BUTTON = "backButton",
    ERROR = "error",
    ERROR_BTN = "errorBtn",
    NOT_IMPLEMENTED = "notImplemented", 
    APP_NAME_VMEDIA = "appNameVmedia",
    APP_NAME_FIZZTV = "appNameFizzTV",
    APP_NAME_RIVERTV = "appNameRiverTV",
    TIME_SHORTHOUR = "time.shortHour",
    TIME_SHORTMINUTE = "time.shortMinute",
    TIME_SHORTSECOND = "time.shortSecond",
    LOGIN_SIGNIN = "login.signin",
    LOGIN_ACCESS_AS_GUEST = "login.accessAsGuest",
    LOGIN_FORGOT_PASSWORD = "login.forgotPassword",
    LOGIN_NEXT = "login.next",
    LOGIN_VISIT = "login.visit",
    LOGIN_PASSWORD = "login.password",
    LOGIN_ENTER_PASSWORD = "login.enterPassword",
    LOGIN_USERNAME = "login.username",
    LOGIN_ENTER_USERNAME = "login.enterUsername",
    LOGIN_USERNAME_VMEDIA = "login.usernameVmedia",
    LOGIN_USERNAME_RIVERTV = "login.usernameRiver",
    LOGIN_USERNAME_FIZZTV = "login.usernameFizzTV",
    LOGIN_ENTER_CREDENTIALS = "login.enterCredentials",
    LOGIN_GET_FREE_TRIAL = "login.getFreeTrial",
    LOGIN_SWITCH_ACCOUNT = "login.switchAccount",
    LOGIN_ERR_INVALID_CREDENTIALS = "login.errors.invalidCredentials",
    LOGIN_ERR_INVALID_LOCATION = "login.errors.invalidLocation",
    LOGIN_ERR_OTHER = "login.errors.other",
    LOGIN_ERR_NETWORK = "login.errors.networkProblem",
    LOGIN_ERR_NO_SUBSCRIPTIONS = "login.errors.noSubscriptions",
    LOGIN_ERR_NOT_AVAILABLE = "login.errors.notAvailable",
    LOGIN_RESTORE_PASSWORD_URL_RIVERTV = "login.restorePasswordUrl.RiverTV",
    LOGIN_RESTORE_PASSWORD_URL_VMEDIA = "login.restorePasswordUrl.VMedia",
    LOGIN_RESTORE_PASSWORD_URL_FIZZTV = "login.restorePasswordUrl.FizzTV",
    LOGIN_RESTORE_PASSWORD_URL_FREEDOM = "login.restorePasswordUrl.Freedom",
    LOGIN_FORGOT_RESET_PASSWORD = "login.forgot.resetPassword",
    LOGIN_FORGOT_VISIT = "login.forgot.visit",
    LOGIN_FORGOT_OR = "login.forgot.or",
    LOGIN_FORGOT_SCAN = "login.forgot.scan",
    LOGIN_OKTA_FIZZ_TITLE = "login.okta.FizzTV.title",
    LOGIN_OKTA_FIZZ_GO_TO_WEBSITE = "login.okta.FizzTV.goToWebsite",
    LOGIN_OKTA_FIZZ_AUTH_CODE = "login.okta.FizzTV.authCode",
    LOGIN_OKTA_FIZZ_AUTH_TIMER = "login.okta.FizzTV.timer",
    LOGIN_OKTA_FIZZ_OR = "login.okta.FizzTV.or",
    LOGIN_OKTA_FIZZ_SCAN = "login.okta.FizzTV.scan",
    LOGIN_OKTA_FIZZ_FOOTNOTE = "login.okta.FizzTV.footnote",
    LOGIN_OKTA_FIZZ_BUTTON = "login.okta.FizzTV.button",
    LOGIN_OKTA_FREEDOM_FOOTNOTE = "login.okta.Freedom.footnote",
    LOGIN_OKTA_TOKEN_ERROR_TITLE = "login.okta.tokenError.title",
    LOGIN_OKTA_TOKEN_ERROR_TEXT = "login.okta.tokenError.text",
    LOGIN_OKTA_TOKEN_ERROR_BUTTON = "login.okta.tokenError.button",
    LOGIN_OKTA_SERVER_ERROR_TITLE = "login.okta.serverError.title",
    LOGIN_OKTA_SERVER_ERROR_TEXT = "login.okta.serverError.text",
    LOGIN_OKTA_SERVER_ERROR_BUTTON = "login.okta.serverError.button",
    LOGIN_SIGN_IN_TITILE = "login.signIn.title",
    LOGIN_SIGN_IN_ENTER_CODE = "login.signIn.enterCode",
    LOGIN_SIGN_IN_GET_NEW_CODE = "login.signIn.getNewCode",
    LOGIN_SIGN_IN_CODE_EXPIRED = "login.signIn.expiredCode",
    LOGIN_SIGN_IN_UNAVAILABLE = "login.signIn.unavailable",
    LOGIN_WELCOME_FIRST_TITLE = "login.welcome.firstScreen.title",
    LOGIN_WELCOME_FIRST_SUBTITLE = "login.welcome.firstScreen.subtitle",
    LOGIN_WELCOME_FIRST_INFO_FIRST = "login.welcome.firstScreen.infoFirst",
    LOGIN_WELCOME_FIRST_INFO_SECOND = "login.welcome.firstScreen.infoSecond",
    LOGIN_WELCOME_SECOND_TITLE = "login.welcome.secondScreen.title",
    LOGIN_WELCOME_SECOND_STEP_FIRST = "login.welcome.secondScreen.firstStep",
    LOGIN_WELCOME_SECOND_STEP_SECOND = "login.welcome.secondScreen.secondStep",
    LOGIN_WELCOME_SECOND_STEP_THIRD = "login.welcome.secondScreen.thirdStep",
    MENU_HOME = "menu.home",
    MENU_GUIDE = "menu.guide",
    MENU_ON_DEMAND = "menu.onDemand",
    MENU_SETTINGS = "menu.settings",
    MENU_MYTV = "menu.myTv",
    MENU_SEARCH = "menu.search",
    SETTINGS_NAVIGATION_ACCOUNT = "settings.navigation.account",
    SETTINGS_NAVIGATION_SUBSCRIPTION = "settings.navigation.subscription",
    SETTINGS_NAVIGATION_FAVORITES = "settings.navigation.favorites",
    SETTINGS_NAVIGATION_PARENT= "settings.navigation.parent",
    SETTINGS_NAVIGATION_PRIVACY = "settings.navigation.privacy",
    SETTINGS_NAVIGATION_CLEAR_CACHE = "settings.navigation.clearCache",
    SETTINGS_NAVIGATION_ABOUT_VMEDIA = "settings.navigation.about.VMedia",
    SETTINGS_NAVIGATION_ABOUT_RIVERTV = "settings.navigation.about.RiverTV",
    SETTINGS_NAVIGATION_ABOUT_FIZZTV = "settings.navigation.about.FizzTV",
    SETTINGS_NAVIGATION_ABOUT_FREEDOM = "settings.navigation.about.Freedom",
    SETTINGS_NAVIGATION_PLAYER= "settings.navigation.player",
    SETTINGS_NAVIGATION_DEVMODE = "settings.navigation.devmode",
    SETTINGS_NAVIGATION_SOFTWARE_LICENSE = "settings.navigation.softwareLicense",
    SETTINGS_NAVIGATION_FREEDOM_SERVICE = "settings.navigation.freedomService",
    SETTINGS_NAVIGATION_HELP = "settings.navigation.help",
    SETTINGS_NAVIGATION_LANGUAGE = "settings.navigation.language",
    SETTINGS_VERSION = "settings.version",
    SETTINGS_TITLE = "settings.title",
    SETTINGS_PRIVACY_POLICY_VMEDIA = "settings.privacyPolicy.VMedia",
    SETTINGS_PRIVACY_POLICY_FIZZTV = "settings.privacyPolicy.FizzTV",
    SETTINGS_PRIVACY_POLICY_RIVERTV = "settings.privacyPolicy.RiverTV",
    SETTINGS_PRIVACY_POLICY_FREEDOM = "settings.privacyPolicy.Freedom",
    SETTINGS_PRIVACY_POLICY_QR_TITLE = "settings.privacyPolicy.qrTitle",
    SETTINGS_ABOUT_US_VMEDIA = "settings.aboutUs.VMedia",
    SETTINGS_ABOUT_US_FIZZTV = "settings.aboutUs.FizzTV",
    SETTINGS_ABOUT_US_RIVERTV = "settings.aboutUs.RiverTV",
    SETTINGS_ABOUT_US_FREEDOM = "settings.aboutUs.Freedom",
    SETTINGS_ABOUT_US_QR_TITLE = "settings.aboutUs.qrTitle",
    SETTINGS_HELP_FIZZ_FAQ_TITLE = "settings.help.FizzTV.faqTitle",
    SETTINGS_HELP_FIZZ_FAQ_DESCRIPTION = "settings.help.FizzTV.faqDescription",
    SETTINGS_HELP_FIZZ_FORUM_TITLE = "settings.help.FizzTV.forumTitle",
    SETTINGS_HELP_FIZZ_FORUM_DESCRIPTION = "settings.help.FizzTV.forumDescription",
    SETTINGS_HELP_FIZZ_SUPPORT_TITLE = "settings.help.FizzTV.supportTitle",
    SETTINGS_HELP_FIZZ_SUPPORT_DESCRIPTION = "settings.help.FizzTV.supportDescription",
    SETTINGS_HELP_FIZZ_SUPPORT_SWITCH_FIRST_INSTRUCTIONS = "settings.help.FizzTV.supportSwitch.firstInstructions",
    SETTINGS_HELP_FIZZ_SUPPORT_SWITCH_SECOND_INSTRUCTIONS = "settings.help.FizzTV.supportSwitch.secondInstructions",
    SETTINGS_HELP_FIZZ_SUPPORT_SWITCH_QRLINK = "settings.help.FizzTV.supportSwitch.qrCodeLink",
    SETTINGS_HELP_FIZZ_VISIT = "settings.help.FizzTV.visit",
    SETTINGS_ACCOUNT_TITLE = "settings.account.title",
    SETTINGS_CLEAR_CACHE_BTN_CAPTION = "settings.clearCache.btnCaption",
    SETTINGS_CLEAR_CACHE_TITLE = "settings.clearCache.title",
    SETTINGS_CLEAR_CACHE_TOTAL = "settings.clearCache.total",
    SETTINGS_CLEAR_CACHE_USAGE = "settings.clearCache.usage",
    SETTINGS_CLEAR_CACHE_MB = "settings.clearCache.mb",
    SETTINGS_CLEAR_CACHE_TOOLTIPE_MSG = "settings.clearCache.tooltipeMsg",
    SETTINGS_ACCOUNT_GUEST_USER_NAME = "settings.account.guestUserName",
    SETTINGS_ACCOUNT_BTN_SIGN_IN = "settings.account.buttonSignIn",
    SETTINGS_ACCOUNT_BTN_SIGN_OUT = "settings.account.buttonSignOut",
    SETTINGS_ACCOUNT_MODAL_TXT = "settings.account.modalText",
    SETTINGS_ACCOUNT_MODAL_POSITIVE = "settings.account.modalPositive",
    SETTINGS_ACCOUNT_MODAL_NEGATIVE = "settings.account.modalNegative",
    SETTINGS_ACCOUNT_MODAL_CLOSE = "settings.account.modalClose",
    SETTINGS_ACCOUNT_MODAL_RETRY = "settings.account.modalRetry",
    SETTINGS_PARENT_CONTROL_RATINGS_RATING = "settings.parentControl.ratings.rating",
    SETTINGS_PARENT_CONTROL_RATINGS_NO_RESTRICTION = "settings.parentControl.ratings.noRestriction",
    SETTINGS_PARENT_CONTROL_RATINGS_G = "settings.parentControl.ratings.g",
    SETTINGS_PARENT_CONTROL_RATINGS_PG = "settings.parentControl.ratings.pg",
    SETTINGS_PARENT_CONTROL_RATINGS_STRONGLY_CAUTIONED = "settings.parentControl.ratings.stronglyCautioned",
    SETTINGS_PARENT_CONTROL_RATINGS_RESTRICTED = "settings.parentControl.ratings.restricted",
    SETTINGS_PARENT_CONTROL_UNLOCK_TIMES_UNLOCK_TIME = "settings.parentControl.unlockTimes.unlockTime",
    SETTINGS_PARENT_CONTROL_UNLOCK_TIMES_ASK_ALWAYS = "settings.parentControl.unlockTimes.askAlways",
    SETTINGS_PARENT_CONTROL_UNLOCK_TIMES_ONE_HOUR = "settings.parentControl.unlockTimes.oneHour",
    SETTINGS_PARENT_CONTROL_UNLOCK_TIMES_TWO_HOUR  = "settings.parentControl.unlockTimes.twoHour",
    SETTINGS_PARENT_CONTROL_UNLOCK_TIMES_FOUR_HOUR  = "settings.parentControl.unlockTimes.fourHour",
    SETTINGS_PARENT_CONTROL_RELOGIN_TITLE  = "settings.parentControl.reloginTitle",
    SETTINGS_PARENT_CONTROL_FORGOT_TITLE  = "settings.parentControl.forgotTitle",
    SETTINGS_PARENT_CONTROL_ADULT_PIN_TITLE = "settings.parentControl.adultPin.title",
    SETTINGS_PARENT_CONTROL_ADULT_PIN_ERROR = "settings.parentControl.adultPin.error",
    SETTINGS_PARENT_CONTROL_ADULT_PIN_FORGOT = "settings.parentControl.adultPin.forgot",
    SETTINGS_FAVORITES_SAVE = "settings.favorites.save",
    SETTINGS_FAVORITES_ERROR = "settings.favorites.error",
    SETTINGS_FAVORITES_SEARCH_ENTER_TEXT = "settings.favorites.search.enterText",
    SETTINGS_FAVORITES_SEARCH_NOTHING_WAS_FOUND = "settings.favorites.search.nothingWasFound",
    SETTINGS_FAVORITES_SEARCH_TRY_DIFFERENT_KEYWORD = "settings.favorites.search.tryDifferentKeyword",
    SETTINGS_FAVORITES_SEARCH_SEARCH_FOR = "settings.favorites.search.searchFor",
    SETTINGS_PLAYER_AUTOPLAY = "settings.player.autoplay",
    SETTINGS_PLAYER_ON = "settings.player.on",
    SETTINGS_PLAYER_OFF = "settings.player.off",
    SETTINGS_SOFTWARE_LICENSE_URL = "settings.softwareLicense.url",
    SETTINGS_SERVICE_TEXT = "settings.service.text",
    SETTINGS_LANGUAGES_EN = "settings.languages.en",
    SETTINGS_LANGUAGES_FR = "settings.languages.fr",
    SETTINGS_LANGUAGES_SYSTEM = "settings.languages.system",
    DEVMODE_TITLE = "devmode.title",
    DEVMODE_ENVIRONMENT_API_TITLE = "devmode.apiEnvironment.title",
    DEVMODE_ENVIRONMENT_API_DESCRIPTION = "devmode.apiEnvironment.description",
    DEVMODE_ENVIRONMENT_API_PREVIEW = "devmode.apiEnvironment.preview",
    DEVMODE_ENVIRONMENT_API_PROD = "devmode.apiEnvironment.prod",
    DEVMODE_ENVIRONMENT_OKTA_API_TITLE = "devmode.oktaEnvironment.title",
    DEVMODE_ENVIRONMENT_OKTA_API_DESCRIPTION = "devmode.oktaEnvironment.description",
    DEVMODE_ENVIRONMENT_OKTA_API_PREVIEW = "devmode.oktaEnvironment.preview",
    DEVMODE_ENVIRONMENT_OKTA_API_PROD = "devmode.oktaEnvironment.prod",
    DEVMODE_RESET_TITLE = "devmode.reset.title",
    DEVMODE_RESET_DESCRIPTION = "devmode.reset.description",
    DEVMODE_RESET_BUTTON = "devmode.reset.button",
    VOD_CHANNELS = "vod.channels",
    VOD_FIZZ_CHANNELS = "vod.fizzChannels",
    VOD_NEW_SHOWS = "vod.newReleasedShows",
    VOD_NEW_MOVIES = "vod.newReleasedMovies",
    VOD_RECOMMENDED_SHOWS = "vod.recommendedShows",
    VOD_RECOMMENDED_MOVIES = "vod.recommendedMovies",
    VOD_SUBGENRES = "vod.subgenres",
    VOD_DETAIL_GENRES = "vod.detailGenre",
    VOD_BTN_WATCHING_NAME = "vod.btnWatchingName",
    VOD_MOST_POPULAR = "vod.mostPopular",
    VOD_NEW_RELEASES = "vod.newReleases",
    VOD_ALL = "vod.all",
    VOD_TV_SHOWS = "vod.tvShows",
    VOD_MOVIES = "vod.movies",
    HOME_RECENT_CHANNELS = "home.recentChannels",
    HOME_MOVIES = "home.movies",
    HOME_SPORTS = "home.sports",
    HOME_KIDS = "home.kids",
    HOME_NEWS = "home.news",
    HOME_LIVE = "home.live",
    HOME_CONTINUE_WATCHING = "home.continueWatching",
    HOME_FIZZ_MOVIES = "home.fizzMovies",
    HOME_FIZZ_SPORTS = "home.fizzSports",
    HOME_FIZZ_KIDS = "home.fizzKids",
    HOME_FIZZ_NEWS = "home.fizzNews",
    HOME_FIZZ_CONTINUE_WATCHING = "home.fizzContinueWatching",
    HOME_RECENTLY_ON_DEMAND = "home.recentlyOnDemand",
    HOME_WATCH_AGAIN = "home.watchAgain",
    HOME_TRENDS = "home.trends",
    HOME_OLYMPICS = "home.olympics",
    HOME_LIVE_SERIES = "home.liveSeries",
    CAST_PAGE_BORN = "castPage.born",
    CAST_PAGE_RELATED_TITLE = "castPage.relatedTitle",
    DETAILS_SEASON = "details.season",
    DETAILS_BTNS_ADD = "details.btns.add",
    DETAILS_BTNS_PLAY = "details.btns.play",
    DETAILS_BTNS_RESUME = "details.btns.resume",
    DETAILS_BTNS_REMOVE = "details.btns.remove",
    DETAILS_BTNS_TRAILER = "details.btns.trailer",
    DETAILS_BTNS_CHANNEL = "details.btns.channel",
    DETAILS_BTNS_SEASON = "details.btns.season",
    DETAILS_BTNS_GO_TO_CHANNEL = "details.btns.goToChannel",
    DETAILS_CASTNCREW_TITLE = "details.castNCrew.title",
    DETAILS_RELATED_CONTENT_TITLE = "details.relatedContent.title",
    DETAILS_CHANNEL_MODAL_TITLE = "details.channelModal.title",
    DETAILS_LIVE_SPORT_LABEL_LIVE = "details.liveSportLabel.live",
    DETAILS_LIVE_SPORT_LABEL_REBROADCAST = "details.liveSportLabel.rebroadCast",
    DETAILS_LIVE_SPORT_LABEL_UPCOMING = "details.liveSportLabel.upcoming",
    DETAILS_TOOLTIP_ERROR_OPENING_DETAILS_PAGE = "details.tooltips.errorOpeningDetailsPage",
    DETAILS_TOOLTIP_ERROR_PLAY_DETAILS_PAGE = "details.tooltips.errorPlayDetailsPage",
    PLAYER_TOOLTIP_ERROR_OPENING_PLAYER_PAGE = "player.tooltips.errorOpeningPlayerPage",
    PLAYER_TOOLTIP_ERROR_STARTING_CHANNEL = "player.tooltips.errorStartingChannel",
    SEARCH_NOTHING_WAS_FOUND = "search.nothingWasFound",
    SEARCH_TRY_DIFFERENT_KEYWORD = "search.tryDifferentKeyword",
    SEARCH_YOU_CAN_SEARCH = "search.youCanSearch",
    SEARCH_SEARCH_FOR = "search.searchFor",
    SEARCH_LIVE_TV = "search.liveTv",
    SEARCH_CHANNELS = "search.channels",
    SEARCH_MOVIES_ON_DEMAND = "search.moviesOnDemand",
    SEARCH_MOVIES_ON_DEMAND_FIZZ = "search.moviesOnDemandFizz",
    SEARCH_TV_SHOWS_ON_DEMAND = "search.tvShowsOnDemand",
    SEARCH_TV_SHOWS_ON_DEMAND_FIZZ = "search.tvShowsOnDemandFizz",
    SEARCH_CAST_AND_CREW = "search.castAndCrew",
    SEARCH_ENTER_TEXT = "search.enterText",
    HOME_EXIT_APP = "home.exitApp",
    HOME_CONFIRM_EXIT_APP = "home.confirmExitApp",
    PLAYER_CONTENT_NOT_AVAILABLE_TITLE = "player.contentNotAvailableTitle",
    PLAYER_CONTENT_NOT_AVAILABLE_MSG = "player.contentNotAvailableMessage",
    PLAYER_CONFIRM_STOP_PLAYING_TITLE = "player.confirmStopPlayingTitle",
    PLAYER_CONFIRM_STOP_PLAYING_MSG = "player.confirmStopPlayingMessage",
    PLAYER_INFO = "player.info",
    PLAYER_ADD = "player.add",
    PLAYER_REMOVE = "player.remove",
    PLAYER_SUBTITLES = "player.subtitles",
    PLAYER_PLAY = "player.play",
    PLAYER_PAUSE = "player.pause",
    PLAYER_REWIND = "player.rewind",
    PLAYER_FAST_FORWARD = "player.fastForward",
    PLAYER_LIVE = "player.live",
    PLAYER_RESET = "player.reset",
    PLAYER_SKIP_NEXT = "player.skipNext",
    PLAYER_SKIP_PREV = "player.skipPrev",
    PLAYER_PROGRAM_ENDED = "player.programEnded",
    PLAYER_FUNCTION_UNAVAILABLE = "player.functionUnavailable",
    PLAYER_ERROR_START_LIVE_PROGRAM = "player.errorStartLiveProgram",
    PLAYER_ERROR_SWITCH_CHANNEL = "player.errorSwitchChannel",
    PLAYER_ERROR_SWITCH_PROGRAM = "player.errorSwitchProgram",
    PLAYER_ERROR_SWITCH_EPISODE = "player.errorSwitchEpisode",
    PLAYER_ERROR_RECONNECTION = "player.errorReconnection",
    PLAYER_BUFFERING = "player.buffering",
    PLAYER_REPLAY = "player.replay",
    PLAYER_VOLUME = "player.volume",
    PLAYER_CHANNELS = "player.channels",
    PLAYER_EPISODES = "player.episodes",
    PLAYER_SUBTITLES_ONLY = "player.subtitlesOnly",
    PLAYER_SUBTITLE_ON = "player.subtitlesOn",
    PLAYER_SUBTITLE_OFF = "player.subtitlesOff",
    PLAYER_BACK = "player.back",
    MY_TV_FAVORITE_CHANNELS = "myTv.favoriteChannels",
    MY_TV_FAVORITE_ON_DEMAND = "myTv.favoriteOnDemand",
    MY_TV_ADD_FAVORITE_CHANNELS = "myTv.addFavoriteChannels",
    MY_TV_SEE_ON_DEMANDS = "myTv.seeOnDemands",
    MY_TV_ALL_ON_DEMANDS = "myTv.allOnDemand",
    MY_TV_FAV_CHANNELS = "myTv.showAllFavChannels",
    MY_TV_ALL_PROGRAMS = "myTv.allPrograms",
    MY_TV_MY_WATCH_LIST = "myTv.myWatchList",
    MY_TV_CONTINUE_WATCHING = "myTv.continueWatching",
    MY_TV_SEE_PROGRAMS_IN_GUIDE = "myTv.seeProgramsInGuide",
    ADVISORY_TEXT = "advisory",
    CARD_NOW_PLAYING = "cards.nowPlaying",
    CARD_TODAY_AT = "cards.todayAt",
    CARD_AT = "cards.at",
    CARD_TOMORROW_AT = "cards.tomorrowAt",
    CARD_YESTERDAY_AT = "cards.yesterdayAt",
    CARD_REMOVED = "cards.removed",
    NOT_SUPPORTED_PLATFORM = "notSupported.text",
    SUBTITLES_MODAL_TITLE = "subtitlesModal.title",
    SUBTITLES_MODAL_SUBTITLE = "subtitlesModal.subtitle",
    SUBTITLES_MODAL_AUDIO = "subtitlesModal.audio",
    SUBTITLES_MODAL_OFF = "subtitlesModal.off",
    SUBTITLES_MODAL_ENGLISH_DESCRIBED_VIDEO = "subtitlesModal.englishDescribedVideo",
    SUBTITLES_MODAL_DESCRIPTIVE_AUDIO = "subtitlesModal.descriptiveAudio",
    SUBTITLES_MODAL_ORIGINAL_AUDIO = "subtitlesModal.originalAudio",
    SUBTITLES_MODAL_CLOSED_CAPTION = "subtitlesModal.closedCaption",
    HIGH_DEFINITION = "highDefinition",
    CLOSED_CAPTIONS = "closedCaptions",
    SHOW_ALL = "showAll",
    HOME_NO_INTERNET = "home.noInternet",
    HOME_CHECK_CONNECTION = "home.checkConnection",
    CANCEL_BUTTON = "cancelButton",
    PREVIEW_MODE = "previewMode",
    CONTENT_UNAVAILABLE_SIGN_IN_RIVERTV = "contentUnavailableSingIn.RiverTV",
    CONTENT_UNAVAILABLE_SIGN_IN_VMEDIA = "contentUnavailableSingIn.VMedia",
    CONTENT_UNAVAILABLE_SIGN_IN_FIZZTV = "contentUnavailableSingIn.FizzTV",
    CONTENT_UNAVAILABLE_SIGN_IN_FREEDOM = "contentUnavailableSingIn.Freedom",
    GUIDE_FAVORITE_CHANNLES = "guide.favoriteChannels",
    GUIDE_CHANNEL_FILTER = "guide.channelFilter",
    GUIDE_EMPTY_DATA = "guide.emptyData",
    GUIDE_EMPTY_DATA_TITLE = "guide.emptyDataTitle",
    GUIDE_EMPTY_DATA_MSG = "guide.emptyDataMsg",
    GUIDE_EMPTY_DATA_BTN = "guide.emptyDataBtn", 
    GUIDE_WAITING = "guide.waiting",
    GUIDE_BTN_WATCH = "guide.btnWatch",
    GUIDE_TODAY = "guide.today",
    GUIDE_YESTERDAY = "guide.yesterday",
    GUIDE_TOMORROW = "guide.tomorrow",
    GUIDE_ERRORE_CHANNELS_SEGMENTS = "guide.erroreChannelsSegments",
    GUIDE_FILTER_TABS_ALL = "guide.filterTabs.all",
    GUIDE_FILTER_TABS_SUBSCRIBED = "guide.filterTabs.subscribed",
    GUIDE_FILTER_TABS_FAVOURITES = "guide.filterTabs.favourites",
    GUIDE_FILTER_TABS_OUT_OF_HOME = "guide.filterTabs.out_of_home",
    GUIDE_MANAGER_TOOLTIP = "guide.guideManager.tooltip",
    RELOAD_MODAL_TITLE = "reloadModal.title",
    RELOAD_MODAL_MESSAGE = "reloadModal.message",
    RELOAD_MODAL_BTN_CANCEL = "reloadModal.btnCancel",
    RELOAD_MODAL_BTN_CONFIRM = "reloadModal.btnConfirm",
    VIZIT_ONE_URL_TITLE = "vizitOne.urlTitle",
    VIZIT_ONE_URL_OR = "vizitOne.or",
    VIZIT_ONE_URL_QR_TITLE = "vizitOne.qrTitle",
    PLAYER_RETRY_MODAL_MESSAGE = "player.retryModalMessage",
    PLAYER_RETRY_MODAL_TRY_BUTTON = "player.retryModalTryButton",
    PLAYER_RETRY_MODAL_CANCEL_BUTTON = "player.retryModalCancelButton",
    MAINTENANCE_MODAL_TITLE = "maintenanceModal.title",
    MAINTENANCE_MODAL_PLAYER_MESSAGE = "maintenanceModal.player.message",
    MAINTENANCE_MODAL_PLAYER_BUTTON = "maintenanceModal.player.btn",
    MAINTENANCE_MODAL_GLOBAL_MESSAGE = "maintenanceModal.global.message",
    MAINTENANCE_MODAL_GLOBAL_BUTTON_DISABLED = "maintenanceModal.global.btnDisabledMessage",
    MAINTENANCE_MODAL_GLOBAL_BUTTON_ENABLED = "maintenanceModal.global.btnEnabledMessage",
    YOUTUBE_ERROR_DEFAULT = "youtubeError.default",
    FATAL_ERROR = "fatalError",
    CHUNK_ERROR = "chunkError",
    SOMETHING_WENT_WRONG = "somethingWentWrong",
}
